import { useCallback, useEffect, useState } from 'react';

export const VETA_CENTER_POLL_INTERVAL_IN_MS = 3000;
export const VETA_CENTER_POLL_WINDOW_IN_MS = 60 * 1000;

export default function useVetaCenterPollWindow() {
  const [isPolling, setIsPolling] = useState(false);
  const [generation, setGeneration] = useState(0);

  useEffect(() => {
    if (!isPolling) return undefined;

    const timeout = setTimeout(() => setIsPolling(false), VETA_CENTER_POLL_WINDOW_IN_MS);

    return () => clearTimeout(timeout);
  }, [isPolling, generation]);

  const startPolling = useCallback(() => {
    setIsPolling(true);
    setGeneration((current) => current + 1);
  }, []);
  const stopPolling = useCallback(() => setIsPolling(false), []);

  return { isPolling, startPolling, stopPolling };
}
